import type { Translations } from './zh';

export const ar: Translations = {
  bubble: {
    open: 'فتح الدردشة',
    close: 'إغلاق الدردشة',
    badge: 'متصل',
    dragHint: 'اضغط مطولاً للسحب',
  },
  panel: {
    closeAria: 'إغلاق لوحة الدردشة',
    languageAria: 'اختيار اللغة',
    welcomeFallback: 'مرحبًا، كيف يمكنني مساعدتك؟',
    quickQuestionsTitle: 'يمكنك تجربة طرح الأسئلة التالية',
    quickAskTitle: 'أسئلة سريعة',
    inputPlaceholder: 'اكتب سؤالك...',
    sendButton: 'إرسال',
    sendAria: 'إرسال الرسالة',
    onlineStatus: 'متصل',
    thinkingAria: 'يفكر',
    aiBusyHint: 'المساعد يرد الآن، يُرجى الانتظار…',
    leadReopenHint: 'اترك معلومات الاتصال هنا عند الحاجة',
    startChat: 'ابدأ الاستشارة',
    welcomeQuickHint: 'تعرّف سريعًا',
    videoPreparing: 'جارٍ تجهيز الفيديو…',
    newMessageTitle: 'رسالة جديدة 💬',
    newMessageBody: 'لديك رسالة جديدة. اضغط للعرض.',
  },
  roles: {
    visitor: 'الزائر',
    ai: 'المساعد الذكي',
    human: 'موظف الدعم',
    system: 'النظام',
  },
  web: {
    aiChat: 'دعم الذكاء الاصطناعي',
    humanChat: 'موظف الدعم',
    switchToHuman: 'التحويل إلى موظف',
    switchToAI: 'العودة إلى الذكاء الاصطناعي',
    resetChat: 'بدء من جديد',
    commonQuestions: 'الأسئلة الشائعة',
    faqTitle: 'الأسئلة المتكررة وإجاباتها',
    selectLanguage: 'اختيار اللغة',
    maximize: 'تكبير',
    restore: 'استعادة',
    offlineLabel: 'غير متصل',
    aiGreeting: 'مرحبًا! أنا مساعدك الذكي. كيف يمكنني مساعدتك اليوم؟',
    humanGreeting: 'مرحبًا، لقد تم توصيلك بأحد موظفي الدعم. كيف يمكنني مساعدتك؟',
    agentOffline: 'موظف الدعم غير متصل',
    agentOfflineMessage: 'عذرًا، موظفونا غير متصلين حاليًا. يرجى مسح رمز QR أدناه لإضافتنا على WeChat.',
    wechatPrompt: 'امسح للإضافة على WeChat',
    wechatHint: 'استخدم WeChat لمسح الرمز وإضافة موظف الدعم',
    serviceHoursLabel: 'ساعات العمل: ',
    viewImage: 'عرض الصورة',
    playVideo: 'تشغيل الفيديو',
    closeViewer: 'إغلاق',
    downloadFile: 'تنزيل',
    fileTypePdf: 'مستند PDF',
    fileTypeWord: 'مستند Word',
    fileTypeExcel: 'جدول بيانات Excel',
    fileTypePpt: 'عرض PowerPoint التقديمي',
    fileTypeArchive: 'ملف مضغوط',
    fileTypeGeneric: 'ملف',
  },
  leadCard: {
    ariaForm: 'نموذج الاتصال',
    title: 'اترك بيانات الاتصال الخاصة بك',
    nameLabel: 'الاسم',
    namePlaceholder: 'اسمك',
    phoneLabel: 'الهاتف',
    phonePlaceholder: 'رقم هاتفك',
    phoneError: 'يرجى إدخال رقم هاتف صحيح',
    submit: 'إرسال',
    submitting: 'جارٍ الإرسال…',
    dismiss: 'لاحقًا',
    success: 'شكرًا لك! سيتواصل معك مستشارنا في أقرب وقت.',
  },
};
